module.exports = __webpack_public_path__ + "static/media/fantasyomatic-ux-onboarding-Artboard-1@2x.628d61cb.png";